/**
 * Lobby slide-friction presets (DROW-104). A preset scales the map's surface friction; the
 * product is clamped to EFFECTIVE_FRICTION_MIN–MAX by `effectiveFriction` (rules/maps).
 * Labels describe slide distance, not a physics term.
 */
export const FRICTION_PRESET_IDS = ['grippy', 'firm', 'normal', 'slick', 'slippery'] as const; // UI order
export type FrictionPreset = (typeof FRICTION_PRESET_IDS)[number];

export const FRICTION_PRESETS: Readonly<Record<FrictionPreset, { label: string; mult: number }>> = {
  grippy: { label: 'Grippy', mult: 1.5 },
  firm: { label: 'Firm', mult: 1.25 },
  normal: { label: 'Normal', mult: 1 },
  slick: { label: 'Slick', mult: 0.8 },
  slippery: { label: 'Slippery', mult: 0.65 },
};

/** Bounds on map surface × preset; the floor keeps an ice-map slide inside the arena. */
export const EFFECTIVE_FRICTION_MIN = 0.2;
export const EFFECTIVE_FRICTION_MAX = 1.5;

export const isFrictionPreset = (v: unknown): v is FrictionPreset =>
  FRICTION_PRESET_IDS.includes(v as FrictionPreset);
